import { useLoaderData } from "react-router";
import { api } from "@/lib/api";
import HomepageLayout from "@/layouts/HomepageLayout";
import SurahsView from "@/components/SurahsView";

import type { Surah } from "@/lib/types";

export const surahsLoader = () => api<Surah[]>("/api/surahs?v=2");

export default function Surahs() {
	const surahs = useLoaderData<Surah[]>();

	return (
		<HomepageLayout>
			<SurahsView surahs={surahs} />
		</HomepageLayout>
	);
}
